import { render, staticRenderFns } from "./Dashcard.vue?vue&type=template&id=67a585ce&scoped=true"
import script from "./Dashcard.vue?vue&type=script&lang=js"
export * from "./Dashcard.vue?vue&type=script&lang=js"
import style0 from "./Dashcard.vue?vue&type=style&index=0&id=67a585ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a585ce",
  null
  
)

export default component.exports